<script setup lang="ts">
import { ref } from 'vue';
import ToolTip from '../ToolTip.vue';
import { locale } from '../../locale';
import DeviceAllert from '../icons/DeviceAllert.vue';
import { cameraDeviceError, desiredMediaState } from '../../states/media/state';
import { mediaActions } from '../../states/media/actions';

const emit = defineEmits(['click'])
const btn = ref<HTMLElement | null>(null)
const toggle = () => {
  if(cameraDeviceError.value) return
  if(desiredMediaState.cameraEnabled) {
    mediaActions.cameraOff()
  } else {
    mediaActions.cameraOn()
  }
}
</script>
<template>
  <button ref="btn" class="camera-button" :class="{
    error: !!cameraDeviceError
  }" @click="toggle">
    <svg
      v-if="desiredMediaState.cameraEnabled"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6927 10.8L20.3401 7.024C20.4434 6.94019 20.5749 6.88313 20.718 6.86003C20.8612 6.83692 21.0096 6.8488 21.1444 6.89417C21.2793 6.93954 21.3946 7.01636 21.4757 7.11493C21.5569 7.21351 21.6003 7.32941 21.6004 7.448V16.552C21.6003 16.6706 21.5569 16.7865 21.4757 16.8851C21.3946 16.9836 21.2793 17.0605 21.1444 17.1058C21.0096 17.1512 20.8612 17.1631 20.718 17.14C20.5749 17.1169 20.4434 17.0598 20.3401 16.976L15.6927 13.2M15.6927 13.2V8.4C15.6927 7.92261 15.4593 7.46477 15.0438 7.12721C14.6284 6.78964 14.0649 6.6 13.4773 6.6L4.33546 6.61446C3.85129 6.66463 3.3981 6.84378 3.04926 7.12721C2.6338 7.46477 2.40039 7.92261 2.40039 8.4V15.6C2.40039 16.0774 2.6338 16.5352 3.04926 16.8728C3.46473 17.2104 4.02822 17.4 4.61578 17.4H13.4773C14.0649 17.4 14.6284 17.2104 15.0438 16.8728M15.6927 13.2L15.6928 15.6C15.6928 16.0774 15.4593 16.5352 15.0438 16.8728M15.0438 16.8728C15.0859 16.8386 15.1261 16.8032 15.1644 16.7666"
        stroke="#292929"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
    <svg
      v-else
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6927 10.8L20.3401 7.024C20.4434 6.9402 20.5749 6.88314 20.718 6.86003C20.8612 6.83692 21.0096 6.8488 21.1444 6.89417C21.2793 6.93954 21.3946 7.01636 21.4757 7.11494C21.5569 7.21351 21.6003 7.32941 21.6004 7.448V16.552C21.6003 16.6706 21.5569 16.7865 21.4757 16.8851C21.3946 16.9836 21.2793 17.0605 21.1444 17.1058C21.0096 17.1512 20.8612 17.1631 20.718 17.14C20.5749 17.1169 20.4434 17.0598 20.3401 16.976L15.6927 13.2V8.4C15.6927 7.92261 15.4593 7.46478 15.0438 7.12721C14.6284 6.78965 14.0649 6.6 13.4773 6.6H9.00039M14.5764 16.976C14.1609 17.3136 14.0649 17.4 13.4773 17.4H4.61578C4.02822 17.4 3.46473 17.2104 3.04926 16.8728C2.6338 16.5352 2.40039 16.0774 2.40039 15.6V8.4C2.40039 7.92261 2.6338 7.46478 3.04926 7.12721C3.3981 6.84378 3.72345 6.6574 4.20762 6.60723M2.40039 4.8L18.0004 20.4"
        stroke="#292929"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
    <ToolTip :placement="'top'" :reference="btn">{{ cameraDeviceError ? locale.deviceErrors.common : desiredMediaState.cameraEnabled ? locale.cameraoff : locale.cameraon }}</ToolTip>
    <div v-if="cameraDeviceError" class="error-allert">
      <DeviceAllert />
    </div>
  </button>
</template>
<style scoped>
.camera-button {
  width: 36px;
  height: 36px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background-color: rgba(236, 236, 236, 0.85);
  border-radius: 50px;
  border: none;
  cursor: pointer;
  position: relative;
}

.error-allert {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 16px;
  height: 16px;
}

.camera-button.error {
  cursor: default;
}

.camera-button:hover:not(.error) {
  background-color: #F6F6F6;
}

.camera-button:active:not(.error) {
  background-color: #DBDBDB;
}

.camera-button:focus:not(.error) {
  outline: none;
}
</style>
